import { render } from "./AppDropdown.vue?vue&type=template&id=0c4b592e&scoped=true"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"

import "./AppDropdown.vue?vue&type=style&index=0&id=0c4b592e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4b592e"]])

export default __exports__